import { ReactNode } from "react";
import { usePageContext } from "../components/Layout";


export type MessagesInput = { [key: string]: { [lang: string]: ReactNode } };
export type Messages<T extends MessagesInput> = { [K in keyof T]: T[K][string] } & { _lang: string }

// New helper type to infer the value type across languages
type ValueType<T> = T extends { [lang: string]: infer V } ? V : never;

export type MessagesOutput<T extends MessagesInput> = {
	[K in keyof T]: ValueType<T[K]>;
} & { _lang: string };

export function makeMessages<T extends MessagesInput>(messages: T): () => MessagesOutput<T> {
	return function useMessages() {
		const { pageMeta: {lang }} = usePageContext();
		return (Object.keys(messages) as (keyof T)[]).reduce((res, key) => ({
			...res,
			[key]: messages[key][lang]
		}), { _lang: lang } as MessagesOutput<T>)
	}
}
